import React from "react";
import { Link } from "react-router-dom";
import { courses } from "../data/courses";

const Courses = () => {
    return (
        <section id="courses" className="font-body">
            <div className="container px-5 py-10 mx-auto text-center lg:px-40">
                <div className="flex flex-col w-full mb-16">
                    <h1 className="sm:text-4xl text-3xl font-medium font-title mb-4">
                        Current Classes
                    </h1>
                    <p className="lg:w-2/3 mx-auto leading-relaxed text-base">
                        Select a course to see more information.
                    </p>
                </div>
                <div className="flex flex-wrap -m-4">
                    {courses.map((course, index) => (
                        <div
                            key={index}
                            className="sm:w-1/2 w-100 p-4">
                            <Link
                                to={{
                                    pathname: `/courseInfo`,
                                    state: { course }
                                }
                                }>
                                <div className="flex relative">
                                    <div className="px-8 py-10 relative z-10 w-full border-2 border-gray-200 rounded-lg hover:bg-secondary hover:text-white">
                                        <h2 className="tracking-widest text-sm font-title font-medium mb-1">
                                            {course.crn}
                                        </h2>
                                        <h1 className="font-title text-lg font-medium mb-3">
                                            {course.title}
                                        </h1>
                                        <p className="leading-relaxed">{course.description}</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
export default Courses;


// WEBPACK FOOTER //
// ./src/components/Courses.jsx